export default __webpack_public_path__ + "static/media/Catie_Friend_AHV_In_Moms_We_Trust.eee26f82.jpg";